import dynamic from 'next/dynamic';

import { Skeleton } from '@ui/components/ui/skeleton';

export const GoogleMapWrapper = dynamic(
  () => import('./GoogleMapWrapper').then((mod) => ({ default: mod.GoogleMapWrapper })),
  {
    ssr: false,
    loading: () => <Skeleton className="h-full w-full rounded-lg" />
  }
);

export default GoogleMapWrapper;
